import React, { useState, useEffect, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { searchTeams } from "../api/searchApi";
import { IoCloseSharp, IoSearchSharp } from "react-icons/io5";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaPlus, FaUserPlus } from "react-icons/fa6";
import { FaCheckCircle, FaMinusCircle, FaRegCalendarAlt, FaTimesCircle, FaTrash, FaUsers } from "react-icons/fa";
import Swal from "sweetalert2";
import { addTeamUsers, deleteTeam, restoreTeam } from "../api/teamApi";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { createUsers } from "../api/userApi";
import { ImExit } from "react-icons/im";
import Pagination from "../components/molecules/Pagination";
import { AiOutlineStop } from "react-icons/ai";
import SearchHistoryModal from "../components/molecules/searchHistoryModal";
import { addSearchHistory, getSearchHistory, removeSearchHistory } from "../utils/store/localStorage";
import SortButton from "../components/molecules/sortButton";
import { RiFileExcel2Fill } from "react-icons/ri";
import TeamRegistModal from "../components/molecules/teamRegistModal";

const validateEmail = (email: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

interface UserRow {
  localId: number;
  email: string;
  nickname: string;
  password: string;
  userId: string;
  username?: string;
  createSuccess: boolean;
  createMessage?: string;
  teamAddSuccess: boolean;
  teamAddMessage?: string;
}

interface ContentItem {
  id: string;
  displayName: string;
  name: string;
  deleteAt: number;
  createAt: number;
  updateAt: number;
  memberCount: number;
}

interface PageInfo {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

const TeamList: React.FC = () => {
  const scrollbarRef = useRef<HTMLElement | null>(null);
  const [data, setData] = useState<ContentItem[]>([]);
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    size: 10,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  });
  const [currentPage, setCurrentPage] = useState(0); // 현재 페이지
  const [currentSize, setCurrentSize] = useState(10); // 현재 사이즈
  const today = new Date();
  const [startDate, setStartDate] = useState<Date>(new Date(2022, 0, 1));
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [keyword, setKeyword] = useState<string>("");
  const [isDeleted, setIsDeleted] = useState<string>("false");

  // 체크박스 컨트롤
  const [allTeamCheck, setAllTeamCheck] = useState<boolean>(false);
  const [selectedTeams, setSelectedTeams] = useState<string[]>([]);

  // 클릭 표시
  const [selectedRow, setSelectedRow] = useState<string>("");

  // 정렬 기준
  const [sortState, setSortState] = useState<string>("");

  const handleSortState = (state: string) => {
    setSortState(state);
  };

  const handleSelectedRow = (id: string) => {
    setSelectedRow(id);
  };

  const handleAllTeamCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAllTeamCheck(event.target.checked); // 현재 체크 상태 업데이트
  };
  // 유서 선택 추가 함수
  const choiceTeamAdd = (teamId: string) => {
    if (teamId && !selectedTeams.includes(teamId)) {
      if (selectedTeams.length === users.length - 1) {
        setAllTeamCheck(true);
        return;
      }
      setSelectedTeams([...selectedTeams, teamId]); // 새로운 채널을 리스트에 추가
    }
  };

  // 유저 선택 취소 함수
  const choiceTeamRemove = (teamId: string) => {
    setSelectedTeams(selectedTeams.filter((t) => t !== teamId)); // 삭제할 팀을 제외하고 리스트 업데이트
    setAllTeamCheck(false);
  };

  useEffect(() => {
    if (allTeamCheck) {
      setSelectedTeams(data.map((team) => team.id));
    } else {
      if (selectedTeams.length === data.length) {
        setSelectedTeams([]);
      }
    }
  }, [allTeamCheck]);
  // 체크박스 컨트롤 끝

  // 여러 팀 한번에 비활성화 활성화 경고창
  const handleMultiTeamConfirm = (state: boolean) => {
    Swal.fire({
      title: `선택한 팀들을 정말 \n${!state ? "비활성화" : "활성화"} 시키시겠습니까?`,
      // text: "이 작업은 되돌릴 수 없습니다.",
      icon: "warning",
      showCancelButton: true, // '아니오' 버튼 추가
      confirmButtonColor: "#3085d6", // '예' 버튼 색상
      cancelButtonColor: "#d33", // '아니오' 버튼 색상
      confirmButtonText: "예",
      cancelButtonText: "아니오",
    }).then((result) => {
      if (result.isConfirmed) {
        // '예'를 선택한 경우 실행할 함수
        if (!state) {
          teamDelete(selectedTeams);
        } else {
          teamRestore(selectedTeams);
        }
      } else {
        // '아니오'를 선택한 경우 실행할 코드
      }
    });
  };

  const teamAPI = async (isSearch: boolean = false) => {
    try {
      const data = await searchTeams(
        isSearch ? 0 : currentPage,
        currentSize,
        startDate.getTime(),
        endDate.getTime() + 1000 * 60 * 60,
        keyword,
        isDeleted,
        sortState
      );

      console.log("teamAPI - 전체 응답:", data);
      console.log("teamAPI - data.data:", data?.data);
      console.log("teamAPI - data.data.content:", data?.data?.content);

      if (data && data.data) {
        const responseData = data.data;
        console.log("teamAPI - responseData:", responseData);
        console.log("teamAPI - responseData.content:", responseData.content);
        console.log("teamAPI - responseData.page:", responseData.page);
        
        if (responseData.page) {
          setPageInfo(responseData.page);
          setCurrentPage(responseData.page.number);
          setCurrentSize(responseData.page.size);
        }
        
        // content가 배열인지 확인하고 설정
        if (Array.isArray(responseData.content)) {
          console.log("teamAPI - content 배열 길이:", responseData.content.length);
          setData(responseData.content);
        } else {
          console.warn("teamAPI - content가 배열이 아닙니다:", responseData.content);
          setData([]);
        }
        
        setAllTeamCheck(false);
        setSelectedTeams([]);
        
        if (Array.isArray(responseData.content) && responseData.content.length > 0) {
          addSearchHistory(keyword.trim(), "team");
        }
      } else {
        console.warn("teamAPI - data 또는 data.data가 없습니다:", data);
        setData([]);
      }
    } catch (error) {
      console.error("teamAPI - 에러 발생:", error);
      setData([]);
    }
  };

  const handleKeyword = (keyword: string) => {
    setKeyword(keyword);
  };

  /* 검색하기 */
  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      teamAPI(true);
    } else if (e.ctrlKey && e.key === " ") {
      handleSearchHistoryModal(true);
    }
  };

  const handleStartDateChange = (date: Date) => {
    setStartDate(date);
    if (endDate && date && date > endDate) {
      setEndDate(date); // 시작 날짜가 종료 날짜를 초과하면 종료 날짜 초기화
    }
  };
  const handleEndDateChange = (date: Date) => {
    if (startDate && date && date < startDate) {
      alert("종료 날짜는 시작 날짜 이후여야 합니다.");
      return;
    }
    setEndDate(date);
  };

  useEffect(() => {
    if (currentPage === 0) {
      teamAPI();
    }
    setCurrentPage(0);
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollTop = 0; // 스크롤 맨 위로 이동
    }
  }, [currentSize]);

  useEffect(() => {
    teamAPI();
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollTop = 0; // 스크롤 맨 위로 이동
    }
  }, [currentPage]);

  useEffect(() => {
    teamAPI();
    if (scrollbarRef.current) {
      scrollbarRef.current.scrollTop = 0; // 스크롤 맨 위로 이동
    }
  }, [sortState, isDeleted, startDate, endDate]);

  const handleCurrentPageChange = (page: number) => {
    handlePageChange(page - 1);
  };

  const handlePageChange = (page: number) => {
    if (page >= 0 && page < pageInfo.totalPages) {
      setCurrentPage(page);
      // setPageInfo((prev) => ({ ...prev, number: page }));
    }
  };
  // n개씩 보기 드롭다운 핸들러
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentSize(Number(event.target.value));
    // setPageInfo((prev) => ({ ...prev, size: Number(event.target.value) }));
  };

  // 상태 활설 비활성 드롭다운 핸들러
  const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsDeleted(event.target.value);
    // setPageInfo((prev) => ({ ...prev, size: Number(event.target.value) }));
  };

  // 비활성화 활성화 경고창
  const handleConfirm = (team: ContentItem) => {
    Swal.fire({
      title: `${team.displayName}팀을 정말 \n${team.deleteAt === 0 ? "비활성화" : "활성화"} 시키시겠습니까?`,
      // text: "이 작업은 되돌릴 수 없습니다.",
      icon: "warning",
      showCancelButton: true, // '아니오' 버튼 추가
      confirmButtonColor: "#3085d6", // '예' 버튼 색상
      cancelButtonColor: "#d33", // '아니오' 버튼 색상
      confirmButtonText: "예",
      cancelButtonText: "아니오",
    }).then((result) => {
      if (result.isConfirmed) {
        // '예'를 선택한 경우 실행할 함수
        if (team.deleteAt === 0) {
          teamDelete([team.id]);
        } else {
          teamRestore([team.id]);
        }
      } else {
        // '아니오'를 선택한 경우 실행할 코드
      }
    });
  };

  const teamDelete = async (teamIds: string[]) => {
    // 원하는 동작을 여기에 추가
    const data = await deleteTeam(teamIds);

    if (data) {
      teamAPI();
    }
  };

  const teamRestore = async (teamIds: string[]) => {
    // 원하는 동작을 여기에 추가
    const data = await restoreTeam(teamIds);

    if (data) {
      teamAPI();
    }
  };

  // 검색창 최신 기록 모달 관련
  const inputRef = useRef<HTMLInputElement>(null);
  const [isSearchHistoryModal, setIsSearchHistoryModal] = useState<boolean>(false);
  const [items, setItems] = useState<string[]>([]);

  const handleSearchHistoryModal = (state: boolean) => {
    setIsSearchHistoryModal(state);
  };

  const removeSearchTeamHistory = (item: string) => {
    removeSearchHistory(item, "team");
    setItems(getSearchHistory("team"));
  };

  useEffect(() => {
    searchAllTeams();
    setItems(getSearchHistory("team"));

    const handleKeyDown = (event: KeyboardEvent) => {
      // '/' 키 입력 감지 (input에 포커스가 없을 때만 작동)
      if (event.key === "/" && document.activeElement !== inputRef.current) {
        event.preventDefault(); // '/' 입력을 방지
        inputRef.current?.focus();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const [isTeamRegistModalOpen, setIsTeamRegistModalOpen] = useState<boolean>(false);

  //  사용자 추가 모달 관련 !!!!
  //  사용자 추가 모달 관련 !!!!
  const [teams, setTeams] = useState<ContentItem[]>([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [overallPassword, setOverallPassword] = useState("");
  const [users, setUsers] = useState<UserRow[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [userAddModal, setUserAddModal] = useState<boolean>(false);
  const [userIdx, setUserIdx] = useState<number>(0);
  const userAddScrollbarRef = useRef<HTMLElement | null>(null);

  const handleUserAddModal = () => {
    teamAPI();
    setUserAddModal(!userAddModal);
    setUsers([]);
    setSelectedTeamId("");
    setOverallPassword("");
    setUserIdx(0);
  };

  const handleAllPassword = () => {
    const changeAll = users.map((user) => (user.createSuccess ? user : { ...user, password: overallPassword }));
    console.log(changeAll);

    setUsers(changeAll);
  };

  const searchAllTeams = async () => {
    const data = await searchTeams(0, 9999, startDate.getTime(), endDate.getTime(), "", "false", "");
    if (data) {
      setTeams(data.data.content);
      console.log(data.data);
    }
  };

  // 새 행 추가
  const handleAddRow = () => {
    const newRow: UserRow = {
      localId: userIdx,
      email: "",
      nickname: "",
      password: "",
      userId: "",
      username: "",
      createSuccess: false,
      createMessage: "",
      teamAddSuccess: false,
      teamAddMessage: "",
    };
    setUserIdx(userIdx + 1);
    setUsers((prev) => [...prev, newRow]);

    setTimeout(() => {
      if (userAddScrollbarRef.current) {
        userAddScrollbarRef.current.scrollTop = userAddScrollbarRef.current.scrollHeight + 10; // 스크롤 맨 아래로 이동
      }
    }, 0);
  };

  // 행 삭제
  const handleDeleteRow = (localId: number) => {
    setUsers((prev) => prev.filter((u) => u.localId !== localId));
  };

  // 계정 생성 버튼 활성화 조건
  const canEnableCreateButton = (user: UserRow): boolean => {
    // 이미 계정 생성 성공했다면 비활성화
    if (user.createSuccess) return false;
    // 닉네임과 이메일이 모두 채워져야 함
    if (!user.nickname.trim()) return false;
    if (!validateEmail(user.email)) return false;
    // 사용자 비번 또는 overallPassword 중 하나가 5글자 이상이어야 함
    const userPwd = user.password.trim();
    // const overallPwd = overallPassword.trim();
    if (userPwd) {
      if (userPwd.length < 5) return false;
    } else {
      return false;
    }
    return true;
  };

  // 단건 계정 생성
  const handleCreateUser = async (user: UserRow) => {
    if (user.createSuccess) return;
    const payload = [
      {
        email: user.email,
        nickname: user.nickname,
        password: user.password,
      },
    ];

    const data = await createUsers(payload);

    if (data) {
      const result = data.data.results[0];
      console.log(result);

      if (result.success) {
        setUsers((prev) =>
          prev.map((u) => {
            if (u.localId === user.localId) {
              return {
                ...u,
                createSuccess: result.success,
                userId: result.userId,
                username: result.username,
                createMessage: result.message,
              };
            }
            return u;
          })
        );
      } else {
        setUsers((prev) =>
          prev.map((u) =>
            u.localId === user.localId
              ? {
                  ...u,
                  createSuccess: false,
                  createMessage: result.message || "계정 생성 실패",
                }
              : u
          )
        );
      }
    }
  };

  // 단건 팀 등록
  const handleTeamRegister = async (user: UserRow) => {
    // 팀 선택 안 됐으면 중단
    if (!selectedTeamId) return;
    // 계정이 생성 성공된 상태가 아니면 중단
    if (!user.createSuccess) return;
    // DB userId가 없으면 중단
    if (!user.userId) return;

    const teamIds = [selectedTeamId];
    const userIds = [user.userId];

    const data = await addTeamUsers(teamIds, userIds);

    if (data) {
      const result = data.data[0];
      console.log(data.data);

      setUsers((prev) =>
        prev.map((u) =>
          u.localId === user.localId
            ? {
                ...u,
                teamAddSuccess: result.success,
                teamAddMessage: result.message,
              }
            : u
        )
      );
    }
  };

  // 전체 계정 생성
  const canEnableCreateAll = () => {
    // (created && createSuccess)가 아닌 사용자들만 검사
    const notCreatedUsers = users.filter((u) => !u.createSuccess);
    if (notCreatedUsers.length === 0) return false;

    for (let u of notCreatedUsers) {
      if (!u.nickname.trim()) return false;
      if (!validateEmail(u.email)) return false;
      const userPwd = u.password.trim();
      // const overallPwd = overallPassword.trim();
      if (userPwd) {
        if (userPwd.length < 5) return false;
      } else {
        return false;
      }
    }
    return true;
  };

  const handleCreateAll = async () => {
    // 이미 계정 생성 성공한 유저는 제외하고, 실패했거나 미시도인 유저만 요청
    const notCreatedUsers = users.filter((u) => !u.createSuccess);
    if (notCreatedUsers.length === 0) return;

    const payload = notCreatedUsers.map((u) => {
      return {
        email: u.email,
        nickname: u.nickname,
        password: u.password,
      };
    });

    const data = await createUsers(payload);

    if (data) {
      const result = data.data.results;
      console.log(result);

      setUsers((prev) =>
        prev.map((u) => {
          if (u.createSuccess) return u; // 이미 성공한 사용자 제외
          const r = result.find((r: any) => r.email === u.email);
          if (r.success) {
            return {
              ...u,
              createSuccess: r.success,
              userId: r.userId,
              username: r.username,
              createMessage: r.message,
            };
          }
          return {
            ...u,
            createSuccess: false,
            createMessage: r.message || "계정 생성 실패",
          };
        })
      );
    }
  };

  // 엑셀/CSV 등록 버튼
  const handleFileButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  // 파일 업로드 핸들러
  const handleFileImport = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isExcel = file.name.endsWith(".xlsx") || file.name.endsWith(".xls");

    if (isExcel) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        if (!evt.target?.result) return;
        const data = new Uint8Array(evt.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const csvData = XLSX.utils.sheet_to_csv(worksheet, {
          FS: ",",
          RS: "\n",
          strip: false,
        });
        Papa.parse(csvData, {
          complete: (results) => {
            const parsedRows = results.data as string[][];
            appendUsersFromRows(parsedRows);
          },
          error: (err) => {
            console.error("CSV 파싱 에러:", err);
          },
        });
      };
      reader.readAsArrayBuffer(file);
    } else {
      // CSV 파일
      Papa.parse(file, {
        complete: (results) => {
          const parsedRows = results.data as string[][];
          appendUsersFromRows(parsedRows);
        },
        error: (err) => {
          console.error("CSV 파싱 에러:", err);
        },
      });
    }
  };

  const excelFailAlert = () => {
    Swal.fire({
      title: "실패",
      text: "엑셀 양식이 일치하지 않습니다.",
      icon: "error", // success, error, warning, info, question 중 선택 가능
      confirmButtonText: "확인",
      timer: 3000, // 알림이 자동으로 사라지는 시간 (ms)
      // timerProgressBar: true, // 타이머 진행 상태를 표시
    });
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/example/student_example.xlsx"; // public 폴더 내 경로
    link.download = "student_example.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 파싱된 row 데이터를 users state에 추가
  const appendUsersFromRows = (parsedRows: string[][]) => {
    const newUsers: UserRow[] = [];
    parsedRows.some((row, idx) => {
      // row[0] = 닉네임, row[1] = 이메일
      if (Array.isArray(row) && row.length >= 2) {
        if (idx === 0 && row[0].trim() !== "교육생" && row[1].trim() !== "이메일") {
          excelFailAlert();
          return true;
        }
        if (idx === 0 && row[0].trim() === "교육생" && row[1].trim() === "이메일") {
          return false;
        }

        const nickname = String(row[0] || "").trim();
        const email = String(row[1] || "").trim();
        if (nickname || email) {
          newUsers.push({
            localId: userIdx + idx,
            email,
            nickname,
            password: "",
            userId: "",
            username: "",
            createSuccess: false,
            createMessage: "",
            teamAddSuccess: false,
            teamAddMessage: "",
          });
        }
      }
    });
    setUserIdx(userIdx + parsedRows.length);
    setUsers((prev) => [...prev, ...newUsers]);
  };

  // 사용자 추가할 때 다른 팀을 선택하면 팀 등록 여부 초기화
  useEffect(() => {
    const teamAddStateReset = users.map((user) => ({ ...user, teamAddSuccess: false, teamAddMessage: "" }));

    setUsers(teamAddStateReset);
  }, [selectedTeamId]);

  // 전체 팀 생성 가능성성
  const canEnableRegisterAllTeam = () => {
    // 팀이 선택되지 않았다면 불가
    if (!selectedTeamId) return false;
    // 이미 팀 등록까지 완료( teamRegistered && teamSuccess )된 사용자 제외
    const notRegisterUsers = users.filter((u) => u.createSuccess && !u.teamAddSuccess);
    if (notRegisterUsers.length === 0) return false;

    return true;
  };

  // 팀 일괄 등록
  const handleTeamRegisterAll = async () => {
    // 팀이 선택되지 않았다면 불가
    if (!selectedTeamId) return;
    // 이미 팀 등록까지 완료( teamRegistered && teamSuccess )된 사용자 제외
    const targetUsers = users.filter((u) => u.createSuccess && !u.teamAddSuccess);
    if (targetUsers.length === 0) return;

    const teamIds = [selectedTeamId];
    const userIds = targetUsers.map((u) => u.userId);

    const data = await addTeamUsers(teamIds, userIds);

    if (data) {
      const results = data.data;
      console.log(data.data);

      setUsers((prev) =>
        prev.map((u) => {
          const matched = results.find((d: any) => d.userId === u.userId);
          if (matched) {
            return {
              ...u,
              teamAddSuccess: matched.success,
              teamAddMessage: matched.message,
            };
          }
          return u;
        })
      );
    }
  };

  return (
    <div
      className="min-h-[80vh] max-h-[80vh] bg-gray-50"
      onClick={() => {
        handleSearchHistoryModal(false);
      }}
    >
      <div className="max-w-full px-4 py-4 mx-auto sm:px-2 lg:px-4">
        <div className="p-4 mb-4 bg-white rounded-lg shadow-sm">
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <div className="flex-1">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="교육과정명, URL 검색"
                    value={keyword}
                    onChange={(e) => handleKeyword(e.target.value)}
                    className="w-full py-2 pl-10 pr-4 border border-gray-300 rounded-md"
                    onKeyDown={handleSearchKeyDown} // Enter 키 이벤트 처리
                    ref={inputRef}
                    onFocus={() => {
                      handleSearchHistoryModal(true);
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSearchHistoryModal(true);
                    }}
                  />
                  <SearchHistoryModal
                    items={getSearchHistory("team")}
                    isOpen={isSearchHistoryModal}
                    onClose={handleSearchHistoryModal}
                    handleKeyword={handleKeyword}
                    inputRef={inputRef}
                    removeSearchTeamHistory={removeSearchTeamHistory}
                  />
                  <span className="absolute text-gray-400 left-3 top-3">
                    <IoSearchSharp size={20} />
                  </span>
                </div>
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    teamAPI(true);
                  }}
                  className="px-4 py-2 text-white bg-black rounded-md hover:bg-gray-700"
                >
                  검색
                </button>
                <button
                  onClick={() => {
                    setKeyword("");
                    setIsDeleted("false");
                    setStartDate(new Date(2022, 0, 1));
                    setEndDate(new Date());
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  초기화
                </button>
              </div>
            </div>

            <div className="flex items-center mt-4">
              <div className="w-full">
                <div className="inline-block w-48 ml-4">
                  <label className="block mb-2 text-sm font-medium text-gray-700">상태</label>
                  <select
                    value={isDeleted}
                    onChange={handleStateChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="false">활성화</option>
                    <option value="true">비활성화</option>
                  </select>
                </div>
                <div className="w-2/3 inline-block ml-[5%]">
                  <h2 className="mb-4 text-lg font-bold">최종 변경 날짜 범위</h2>

                  {/* 날짜 선택 */}
                  <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                    {/* 시작 날짜 선택 */}
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">시작 날짜</label>
                      <DatePicker
                        selected={startDate}
                        onChange={handleStartDateChange}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="시작 날짜를 선택하세요"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        maxDate={endDate} // 종료 날짜를 초과할 수 없음
                      />
                    </div>

                    {/* 종료 날짜 선택 */}
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-700">종료 날짜</label>
                      <DatePicker
                        selected={endDate}
                        onChange={handleEndDateChange}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="종료 날짜를 선택하세요"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                        minDate={startDate} // 시작 날짜보다 이전 날짜를 선택할 수 없음
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 데이터 테이블 */}
        <div className="mb-6 bg-white rounded-lg shadow-sm">
          <div className="p-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <button
                  className="flex items-center px-4 py-2 space-x-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
                  onClick={() => {
                    setIsTeamRegistModalOpen(true);
                  }}
                >
                  <div className="mr-2">
                    <FaPlus size={20} />
                  </div>
                  교육과정 등록
                </button>
                <button
                  className="flex px-4 py-2 text-sm font-medium rounded-md bg-lime-100 text-lime-800 hover:bg-lime-50 disabled:bg-gray-200 disabled:text-gray-500"
                  onClick={() => {
                    handleMultiTeamConfirm(true);
                  }}
                  disabled={selectedTeams.length === 0}
                >
                  <div className="mr-2">
                    <FaCheckCircle size={20} />
                  </div>
                  활성화
                </button>
                <button
                  className="flex px-4 py-2 text-sm font-medium text-red-800 bg-red-100 rounded-md hover:bg-red-50 disabled:bg-gray-200 disabled:text-gray-500"
                  onClick={() => {
                    handleMultiTeamConfirm(false);
                  }}
                  disabled={selectedTeams.length === 0}
                >
                  <div className="mr-2">
                    <AiOutlineStop size={20} />
                  </div>
                  비활성화
                </button>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-600">총 {pageInfo.totalElements}건</span>
                <select
                  className="border border-gray-300 rounded-md focus:ring-custom focus:border-custom"
                  onChange={handleChange}
                  value={currentSize}
                >
                  <option value={10}>10개씩 보기</option>
                  <option value={20}>20개씩 보기</option>
                  <option value={50}>50개씩 보기</option>
                </select>
              </div>
            </div>
          </div>

          {/* 표 보여주는 거 */}
          <div>
            <PerfectScrollbar containerRef={(ref) => (scrollbarRef.current = ref)}>
              <div className="min-h-[45vh] max-h-[45vh]">
                <table className="min-w-full border-collapse divide-y divide-gray-200">
                  <thead className="sticky top-0 bg-gray-50">
                    <tr className="">
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
                      >
                        <input
                          type="checkbox"
                          className="rounded"
                          checked={allTeamCheck}
                          onChange={handleAllTeamCheck}
                        />
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase min-w-[15vw] max-w-[15vw] border-x-2"
                      >
                        <SortButton
                          title="교육과정명"
                          sortState={sortState}
                          sortList={["", "displayName,asc", "displayName,desc"]}
                          handleState={handleSortState}
                        />
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase min-w-[15vw] max-w-[15vw] border-x-2"
                      >
                        <SortButton
                          title="URL"
                          sortState={sortState}
                          sortList={["", "name,asc", "name,desc"]}
                          handleState={handleSortState}
                        />
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-x-2"
                      >
                        <div className="flex w-full">
                          <div className="pt-0.5 mr-2">
                            <FaRegCalendarAlt />
                          </div>
                          <SortButton
                            title="생성 날짜"
                            sortState={sortState}
                            sortList={["", "createAt,asc", "createAt,desc"]}
                            handleState={handleSortState}
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-x-2"
                      >
                        <div className="flex">
                          <div className="pt-0.5 mr-2">
                            <FaRegCalendarAlt />
                          </div>
                          <SortButton
                            title="최종 변경 날짜"
                            sortState={sortState}
                            sortList={["", "updateAt,asc", "updateAt,desc"]}
                            handleState={handleSortState}
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase border-x-2"
                      >
                        <div className="flex">
                          <div className="pt-0.5 mr-2">
                            <FaUsers />
                          </div>
                          멤버수
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
                      >
                        상태
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((team) => (
                      <tr
                        className={`${selectedRow === team.id ? "bg-orange-100" : ""}`}
                        key={team.id}
                        onClick={() => {
                          if (selectedRow === team.id) {
                            handleSelectedRow("");
                          } else {
                            handleSelectedRow(team.id);
                          }
                        }}
                      >
                        <td className="px-6 py-4 whitespace-nowrap">
                          <input
                            type="checkbox"
                            className="rounded"
                            checked={selectedTeams.includes(team.id)}
                            onChange={() => {
                              if (selectedTeams.includes(team.id)) {
                                choiceTeamRemove(team.id);
                              } else {
                                choiceTeamAdd(team.id);
                              }
                            }}
                          />
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 min-w-[15vw] max-w-[15vw] truncate border-x-2">
                          <Link className="hover:text-blue-500" to={`/teamDetail/${team.id}`}>
                            {team.displayName}
                          </Link>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 min-w-[15vw] max-w-[15vw] truncate border-x-2">
                          <a
                            className="hover:text-blue-600"
                            href={`https://mm.jaen.kr/${team.name}`}
                            // href={`http://172.30.1.252:8067/${team.name}`}
                            target="_blank"
                          >
                            https://mm.jaen.kr/{team.name}
                            {/* http://172.30.1.252:8067/{team.name} */}
                          </a>
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap border-x-2">
                          {dayjs(team.createAt).format("YYYY-MM-DD")}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap border-x-2">
                          {dayjs(team.updateAt).format("YYYY-MM-DD")}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap border-x-2">
                          {team.memberCount}명
                        </td>
                        <td className="px-6 py-4 text-sm whitespace-nowrap min-w-[7vw] max-w-[7vw]">
                          <button
                            className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                              ${team.deleteAt === 0 ? "text-green-800 bg-green-100" : "text-red-500 bg-red-200"}`}
                            onClick={() => {
                              handleConfirm(team);
                            }}
                          >
                            {team.deleteAt === 0 ? "활성화" : "비활성화"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </PerfectScrollbar>
          </div>

          <div className="px-6 py-4 border-t border-gray-200">
            <div className="flex items-center justify-center">
              <Pagination
                currentPage={currentPage}
                totalPage={pageInfo.totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 교육과정 등록 모달 띄워줄거!!!!!!!! */}
      <TeamRegistModal
        isOpen={isTeamRegistModalOpen}
        onClose={setIsTeamRegistModalOpen}
        teamAPI={teamAPI}
        teams={teams}
        searchAllTeams={searchAllTeams}
      />
      {/* 교육 과정 모달 끝!!!!!!! */}

      {/* 사용자 추가 모달 시작 !!!! */}
      <div className={`${userAddModal ? "" : "hidden"}`}>
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-60 backdrop-blur-sm"></div>
        <div className="fixed inset-0 z-30 overflow-y-auto">
          <div className="px-4 py-8 mx-auto max-w-8xl sm:px-6 lg:px-8">
            <div className="p-6 mb-6 bg-white rounded-lg shadow-sm">
              <div className="flex items-center justify-between gap-4">
                <div className="relative border w-72 black">
                  <select
                    className="w-full py-2 pl-3 pr-10 text-sm border-black rounded-md focus:ring-black focus:border-black"
                    value={selectedTeamId}
                    onChange={(e) => setSelectedTeamId(e.target.value)}
                  >
                    <option value="">팀 선택</option>
                    {teams.map((team) => (
                      <option key={team.id} value={team.id}>
                        {team.displayName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="relative flex items-center justify-center w-130">
                  <input
                    type="text"
                    placeholder="전체 비밀번호 입력"
                    className="w-full py-2 pl-3 pr-10 text-sm border rounded-md black"
                    value={overallPassword}
                    onChange={(e) => setOverallPassword(e.target.value)}
                  />
                  <button
                    onClick={() => {
                      handleAllPassword();
                    }}
                    className="px-4 py-2 mx-3 text-white bg-black rounded-md hover:bg-gray-700 whitespace-nowrap"
                  >
                    적용
                  </button>
                  <div className="ml-3">
                    <button
                      type="button"
                      className="text-gray-400 hover:text-gray-500"
                      onClick={() => {
                        handleUserAddModal();
                      }}
                    >
                      <span className="sr-only">닫기</span>
                      <IoCloseSharp size={30} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-end">
                  <button
                    className="flex items-center justify-center px-4 py-2 mr-4 space-x-2 text-sm border-2 rounded-md shadow-sm hover:bg-gray-200 hover:font-bold"
                    onClick={handleDownload}
                  >
                    <div className="mr-1 text-green-600">
                      <RiFileExcel2Fill size={20} />
                    </div>
                    엑셀/CSV 양식
                  </button>
                  <button
                    className="flex items-center justify-center px-4 py-2 space-x-2 text-sm border-2 rounded-md shadow-sm hover:bg-gray-200 hover:font-bold"
                    onClick={handleFileButtonClick}
                  >
                    <div className="mr-1 text-green-600">
                      <RiFileExcel2Fill size={20} />
                    </div>
                    엑셀/CSV 등록
                  </button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".xlsx, .xls, .csv"
                    style={{ display: "none" }}
                    onChange={handleFileImport}
                  />
                </div>
              </div>

              {/* 사용자 추가 표 */}
              <div>
                <PerfectScrollbar containerRef={(ref) => (userAddScrollbarRef.current = ref)}>
                  <div className="whitespace-nowrap min-h-[50vh] max-h-[50vh]">
                    <table className="min-w-full divide-y divide-gray-200 table-fixed">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            ID
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase whitespace-nowrap">
                            사용자 ID
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            닉네임
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            이메일
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            비밀번호
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            계정 생성
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            팀 등록
                          </th>
                          <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                            작업
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {users.map((user) => {
                          const isCreateBtnEnabled = canEnableCreateButton(user);
                          const disableEdit = user.createSuccess;
                          return (
                            <tr key={user.localId} className="hover:bg-gray-50">
                              <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">{user.userId ?? ""}</td>
                              <td className="px-6 py-4 overflow-hidden text-sm text-gray-900 whitespace-nowrap text-ellipsis">
                                {user.username || ""}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="text"
                                  value={user.nickname}
                                  className="w-full p-2 border rounded-md black"
                                  disabled={disableEdit}
                                  onChange={(e) =>
                                    setUsers((prev) =>
                                      prev.map((u) =>
                                        u.localId === user.localId ? { ...u, nickname: e.target.value } : u
                                      )
                                    )
                                  }
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="text"
                                  value={user.email}
                                  className="w-full p-2 border rounded-md black"
                                  disabled={disableEdit}
                                  onChange={(e) =>
                                    setUsers((prev) =>
                                      prev.map((u) =>
                                        u.localId === user.localId ? { ...u, email: e.target.value } : u
                                      )
                                    )
                                  }
                                />
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <input
                                  type="text"
                                  value={user.password}
                                  className="w-full p-2 border rounded-md black"
                                  disabled={disableEdit}
                                  onChange={(e) =>
                                    setUsers((prev) =>
                                      prev.map((u) =>
                                        u.localId === user.localId ? { ...u, password: e.target.value } : u
                                      )
                                    )
                                  }
                                />
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                                {user.createMessage === "" ? (
                                  <i className="text-lg text-gray-400">
                                    <FaMinusCircle />
                                  </i>
                                ) : user.createSuccess ? (
                                  <i className="text-lg text-green-500" title={user.createMessage || ""}>
                                    <FaCheckCircle />
                                  </i>
                                ) : (
                                  <i className="text-lg text-red-500 cursor-help" title={user.createMessage || ""}>
                                    <FaTimesCircle />
                                  </i>
                                )}
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                                {user.teamAddMessage === "" ? (
                                  <i className="text-lg text-gray-400">
                                    <FaMinusCircle />
                                  </i>
                                ) : user.teamAddSuccess ? (
                                  <i className="text-lg text-green-500" title={user.teamAddMessage || ""}>
                                    <FaCheckCircle />
                                  </i>
                                ) : (
                                  <i className="text-lg text-red-500 cursor-help" title={user.teamAddMessage || ""}>
                                    <FaTimesCircle />
                                  </i>
                                )}
                              </td>
                              <td className="px-6 py-4 text-sm whitespace-nowrap">
                                <div className="flex gap-2">
                                  <button
                                    className={`rounded-md px-3 py-1.5 whitespace-nowrap ${
                                      isCreateBtnEnabled
                                        ? "bg-black text-white hover:bg-gray-800"
                                        : "bg-gray-100 text-gray-700 cursor-not-allowed"
                                    }`}
                                    disabled={!isCreateBtnEnabled}
                                    onClick={() => handleCreateUser(user)}
                                  >
                                    계정 생성
                                  </button>
                                  <button
                                    className={`rounded-md px-3 py-1.5 ${
                                      user.createSuccess && selectedTeamId && !user.teamAddSuccess
                                        ? "bg-black text-white hover:bg-gray-800"
                                        : "bg-gray-100 text-gray-700 cursor-not-allowed"
                                    }`}
                                    disabled={!user.createSuccess || !selectedTeamId}
                                    onClick={() => handleTeamRegister(user)}
                                  >
                                    팀 등록
                                  </button>
                                  <button
                                    className="rounded-md bg-red-100 px-3 py-1.5 text-red-700 hover:bg-red-200"
                                    onClick={() => handleDeleteRow(user.localId)}
                                    // disabled={user.created && user.createSuccess && user.teamRegistered}
                                  >
                                    <FaTrash />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </PerfectScrollbar>
              </div>
              {/* 사용자 추가 표 끝 */}

              <div className="p-4 border-t border-gray-200">
                <button
                  className="flex items-center justify-center w-full py-3 text-gray-500 border border-gray-300 border-dashed rounded-md hover:bg-gray-50"
                  onClick={handleAddRow}
                >
                  <FaPlus />
                  새로운 행 추가
                </button>
              </div>
            </div>

            <div className="flex justify-center gap-4 mt-6">
              <button
                className={`rounded-md px-8 py-3 text-lg font-medium flex items-center justify-center bg-black text-white hover:bg-gray-800`}
                onClick={() => {
                  handleUserAddModal();
                }}
              >
                <div className="mr-2">
                  <ImExit />
                </div>
                취소
              </button>
              <button
                className={`rounded-md px-8 py-3 text-lg font-medium flex items-center justify-center ${
                  canEnableCreateAll()
                    ? "bg-black text-white hover:bg-gray-800"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                }`}
                disabled={!canEnableCreateAll()}
                onClick={handleCreateAll}
              >
                <div className="mr-2">
                  <FaUserPlus />
                </div>
                계정 일괄 생성
              </button>
              <button
                className={`rounded-md px-8 py-3 text-lg font-medium flex items-center justify-center ${
                  canEnableRegisterAllTeam()
                    ? "bg-black text-white hover:bg-gray-800"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                }`}
                disabled={!selectedTeamId}
                onClick={handleTeamRegisterAll}
              >
                <div className="mr-2">
                  <FaUsers />
                </div>
                팀 일괄 등록
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* 사용자 추가 모달 끗!!!!!! */}
    </div>
  );
};

export default TeamList;
